import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import AutoBindComponent from "../common/AutoBindComponent";
import unsavedDataDialogHandler from "../common/UnsavedDataDialogHandler";
import Section from "../common/Section";
import Fieldset from "../common/Fieldset";

import * as infrastructuurActions from "../../actions/infrastructuurActions";
import * as types from "../../constants/ComponentConstants";
import MinimaleEisenInfoPageHelper from "./MinimaleEisenInfoPageHelper";


class MinimaleEisenInfoPage extends AutoBindComponent {
	constructor(props, context) {
		super(props, context);

		this.pageHelper = new MinimaleEisenInfoPageHelper(this);
	}

	componentWillReceiveProps(nextProps) {
	}

	componentWillMount() {
		this.pageHelper.init();
		this.props.loadInfrastructurenByDossierId(this.props.dossierId);
	}

	render() {
		return (
			<Section title="Minimale Eisen" color={types.COLOR_GREEN_LIGHT}>
				<Fieldset>
					In dit tabblad stellen we vragen rond de minimale eisen waaraan jouw subsidieaanvraag moet voldoen.
					<br /><br />
					Aan de linkerzijde vind je voor elke infrastructuur waarvoor je subsidies aanvraagt een knop om gegevens in te vullen rond het zakelijk recht, de stedenbouwkundige haalbaarheid, de timing en de energetische duurzaamheid.
					<br /><br />
					Aan de linkerzijde vind je ook een knop “algemeen”. Hier dien je gegevens in te vullen rond - eventueel - eerder gestarte werken, de openstelling voor een breed publiek en de tarieven.
					<br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br />
				</Fieldset>
			</Section >
		);
	}
}

MinimaleEisenInfoPage.propTypes = {
};

function mapStateToProps(state, ownProps) {
	const dossierId = ownProps.params.dossierId;

	return {
		dossierId: dossierId
	};
}

function mapDispatchToProps(dispatch, ownProps) {
	return {
		loadInfrastructurenByDossierId: bindActionCreators(infrastructuurActions.loadInfrastructurenByDossierId, dispatch)
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(unsavedDataDialogHandler(MinimaleEisenInfoPage));